import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { useIsMobile, theme, Modal } from '@hub-la/design-system';
import { Drawer } from '@mui/material';
import { Box } from '@mui/system';

const ResponsiveModal = ({
  open,
  onClose,
  children
}) => {
  const isMobile = useIsMobile();
  return isMobile ? jsx(Drawer, Object.assign({
    "data-testid": "responsive-modal-mobile-content",
    anchor: "bottom",
    open: open,
    onClose: onClose,
    PaperProps: {
      sx: {
        borderTopLeftRadius: theme.light.spacing(2),
        borderTopRightRadius: theme.light.spacing(2)
      }
    }
  }, {
    children: jsx(Box, Object.assign({
      padding: 6
    }, {
      children: children
    }))
  })) : jsx(Modal, Object.assign({
    "data-testid": "responsive-modal-desktop-content",
    open: open,
    close: onClose
  }, {
    children: jsx(Box, Object.assign({
      maxWidth: 395
    }, {
      children: children
    }))
  }));
};

export { ResponsiveModal };
